"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimezoneChooser = void 0;
const utils_1 = require("@opsbase/lib-time/utils");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importDefault(require("react"));
const makeDataChooser_1 = __importDefault(require("../helpers/makeDataChooser"));
const ItemChooser_1 = __importDefault(require("../ItemChooser"));
const convertNames = (ids) => {
    return ids.map(id => ({ id, title: (0, utils_1.formatTimezone)(id) }));
};
const allTimezones = convertNames(moment_timezone_1.default.tz.names());
exports.TimezoneChooser = (0, makeDataChooser_1.default)((props) => {
    const { value } = props;
    const formatedValue = convertNames(value === null || value === void 0 ? void 0 : value.map(v => v.id));
    return react_1.default.createElement(ItemChooser_1.default, Object.assign({}, props, { value: formatedValue, items: allTimezones }));
});
exports.default = exports.TimezoneChooser;
